import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {environment} from 'environments/environment';
import {AppModule} from 'app/app.module';
import {TranslocoService} from '@ngneat/transloco';

import config from 'devextreme/core/config';
import {licenseKey} from './devextreme-license';

config({licenseKey});


if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(appRef => {
    const transloco = appRef.injector.get(TranslocoService);
    transloco.langChanges$.subscribe(lang => {
      document.documentElement.lang = lang;
    });
  })
  .catch(err => console.error(err));
